module.exports = __webpack_public_path__ + "static/img/video_default.aca536f3.png";